export const RECEIVE_NOTE_PDF_COLUMNS = [
  'receiveNote',
  'branchName',
  'receiveNoteType',
  'state',
  'warehouse',
  'supplier',
  'deliveryNoteNo',
  'hasFastTrack',
  'purchasePrice',
] as const;
